import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { FAQLink } from '@repo/shared-kit/components/faq-link/faq-link';

export function NotSupportedActivitySubtitle(): ReactNode {
  return (
    <FormattedMessage
      id="customer-registration-kit.register-kyb.unsupported-activity.subtitle"
      values={{
        link: chunks => (
          <FAQLink articleSlug="can_any_organization_open_qonto_account">{chunks}</FAQLink>
        ),
      }}
    />
  );
}
